.content {
  padding: 1.2rem 1.7rem;
  max-width: 25rem;
}
